import React, { useState } from "react";
import { useSelector } from "react-redux"; 
import { AiOutlineDown } from "react-icons/ai";
import { MenuItem, Menu } from "@mui/material"; 
import '../../assets/styles/project-picker.css';
import { ROLES } from '../../cmps/../services/user.service';

export function ProjectPicker({ customHeight, info, field, onUpdate, userRol }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(info.idproyecto);
    const [anchorEl, setAnchorEl] = useState(null);
    const isEditable = userRol === ROLES.ADMIN;

    const DataInfo = useSelector(storeState => storeState.infoModulo.infoM);
    const projectOptions = DataInfo?.projectOptions || [];

    function handleProjectChange(ev, project) {
        if (!isEditable) return;
        ev.preventDefault();
        setSelectedProject(project.id_proyecto);
        setIsOpen(false);
        onSave(ev, project.id_proyecto);
    }

    function onSave(ev, projectId) {
        onUpdate(ev, field, projectId);
    }

    const selectedOption = projectOptions.find(opt => opt.id_proyecto === selectedProject);

    return (
        <div className="status-picker picker" style={{ alignContent: "center", height: customHeight, width: "170px" }}>
            <div
                className="selected-status"
                onClick={(ev) => {
                    if (isEditable) {
                        setAnchorEl(ev.currentTarget);
                        setIsOpen(!isOpen);
                    }
                }}
                style={{
                    backgroundColor: selectedOption?.bgColor || '#ffffff',
                    color: selectedOption?.fontColor || '#ffffff',
                    height: customHeight,
                    cursor: isEditable ? 'pointer' : 'not-allowed',
                    fontSize: "14px",
                }}
            >
                {selectedOption?.nombre_proyecto || "Seleccione un proyecto"}
                <AiOutlineDown className="dropdown-icon" />
            </div>
            {isOpen && (
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setIsOpen(false)}
                    PaperProps={{
                        style: {
                            maxHeight: 200,
                            width: "171px",
                            overflowX: "auto", // Habilita el scroll horizontal
                            whiteSpace: "nowrap", // Evita el salto de línea en los nombres largos
                           
                        },
                    }}
                >
                    {projectOptions.map(option => (
                         <MenuItem
                         key={option.id_proyecto}
                         onClick={(ev) => handleProjectChange(ev, option)}
                         selected={option.id_proyecto === selectedProject}
                         style={{
                             backgroundColor: option.bgColor,
                             color: option.fontColor,
                             paddingRight: "15px",
                             whiteSpace: "normal", // Permite salto de línea
                             wordWrap: "break-word", // Asegura que el texto largo se ajuste al ancho
                            fontSize: "14px",
                         }}
                     >
                            {option.nombre_proyecto}
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </div>
    );
}
